export class TargetAudience {
    public id: number;
    public name: string;
}